/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/

/* eslint-disable camelcase */
import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import { UNIT } from '@hems/util/src/constant/unit';
import { getKwhData } from '@hems/util/src/helper/helper';
import { formatUnitNumber } from '@hems/util/src/helper/numberformatHelper';

import type { CommonResponseWrapper, FormattedUnitNumberData } from 'hems';

import type { BaseDeviceInfo } from 'hems/device';
import type { Interval, ReportIntervalParams, ReportIntervalResponse, ReportIntervalResult } from 'hems/report';

const getAccumulatedData = (data: ReportIntervalResult): ReportIntervalResult => {
  const {
    gen_data = [],
    con_data = [],
    core_data = [],
    btc_data = [],
    btd_data = [],
    feedin_data = [],
    demand_data = [],
  } = data;

  const defaultValue: FormattedUnitNumberData = formatUnitNumber(0, UNIT.WATT_HOUR);

  return {
    ...data,
    gen_kwh: gen_data ? getKwhData(gen_data) : defaultValue,
    con_kwh: con_data ? getKwhData(con_data) : defaultValue,
    core_kwh: core_data ? getKwhData(core_data) : defaultValue,
    btc_kwh: btc_data ? getKwhData(btc_data) : defaultValue,
    btd_kwh: btd_data ? getKwhData(btd_data) : defaultValue,
    feedin_kwh: feedin_data ? getKwhData(feedin_data) : defaultValue,
    demand_kwh: demand_data ? getKwhData(demand_data) : defaultValue,
  };
};
export default class UserReportService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  /** 서버 시간 조회 */
  getServerTime = async (timezoneId: string): Promise<string> => {
    const { data } = await this.get<CommonResponseWrapper<string>>(apiWrapper.managerApi('/managements/commons/now'), {
      timezoneId,
    });

    return data;
  };

  /** 주기별 차트 조회 */
  getReportsByInterval = async (interval: Interval, params: ReportIntervalParams): Promise<ReportIntervalResponse> => {
    const { from, to, type, site_id } = params;
    const reportParams = { from, to, type, site_id, interval };
    const { data } = await this.get<CommonResponseWrapper<ReportIntervalResponse>>(
      apiWrapper.managerApi('/histories/user-reports'),
      reportParams
    );

    return {
      ...data,
      result: getAccumulatedData(data.result),
    };
  };

  /** Overview 차트 조회 (Home Web) */
  getOverview = async (params: BaseDeviceInfo): Promise<ReportIntervalResponse> => {
    const overviewParams = { site_id: params.site_id };
    const { data } = await this.get<CommonResponseWrapper<ReportIntervalResponse>>(
      apiWrapper.managerApi('/histories/user-reports/overviews'),
      overviewParams
    );

    return data;
  };
}

export { UserReportService };
